import { cn } from '@/lib/utils';

/**
 * Les classes du bouton, sans l'élément — pour habiller un `<Link>` ou un `<a>`
 * qui doit ressembler à un bouton sans en être un.
 *
 * Ce module n'est volontairement PAS marqué `'use client'` : les composants
 * serveur (la landing entière) appellent cette fonction, ce qu'ils ne peuvent
 * pas faire sur un module client.
 */
export type ButtonVariant = 'primary' | 'navy' | 'gold' | 'ghost' | 'ghostDark' | 'soft';

export const BUTTON_VARIANTS: Record<ButtonVariant, string> = {
  primary: 'bg-green text-white shadow-btn-green hover:shadow-btn-green-hover',
  navy: 'bg-navy text-white',
  gold: 'bg-gold text-navy-d',
  ghost: 'bg-transparent text-navy border-line',
  ghostDark: 'bg-white/8 text-white border-white/28',
  soft: 'bg-green-bg text-green-d',
};

export function buttonClasses({
  variant = 'primary',
  sm = false,
  className,
}: {
  variant?: ButtonVariant;
  sm?: boolean;
  className?: string;
} = {}): string {
  return cn(
    // `group` ne coûte rien aux boutons sans enfant `group-hover:` (icône
    // flèche des CTA primaires, hero.tsx/cta-section.tsx) — pur marqueur.
    'group inline-flex cursor-pointer items-center justify-center gap-2 rounded-btn border-[1.5px] border-transparent font-sans font-semibold whitespace-nowrap',
    'transition-[transform,background,box-shadow] duration-150 hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.97] active:duration-75',
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold',
    'disabled:pointer-events-none disabled:opacity-55',
    sm ? 'px-4 py-[9px] text-[14px]' : 'px-[22px] py-[13px] text-[15px]',
    BUTTON_VARIANTS[variant],
    className,
  );
}
